/* src/router/index.js */
import { createRouter, createWebHistory } from 'vue-router'
import { getActivePinia } from 'pinia'
import LoginView from '../views/Login/LoginView.vue'

const routes = [
  {
    path: '/',
    name: 'root',
    redirect: to => {
    
      const hasUserToken = !!localStorage.getItem('user-token')
      const isDeviceRegistered = localStorage.getItem('device-registered') === 'true'
      console.log("🚀 Accesso a freddo su della radice (/). Controllo chiavi:", { hasUserToken, isDeviceRegistered })

      if (hasUserToken) {
    
        return { name: 'user-menu' }
      }
    
      if (isDeviceRegistered) {
    
        return { name: 'login' }
      }
      
      return { name: 'intermedia' }
    }
  },
  {
    path: '/intermedia',
    name: 'intermedia',
    component: () => import('@/views/Intermedia/Intermedia.vue') // Il tuo componente attuale
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login/LoginView.vue')
  },
  {
    path: '/user-menu',
    name: 'user-menu',
    component: () => import('@/views/UserMenu/UserMenu.vue'),
    meta: { requiresAuth: true }
  },
  { 
    path: '/booking-wizard', 
    name: 'booking-wizard',
    component: () => import('../views/BookingWizard/BookingWizard.vue'),
    meta: { requiresAuth: true }
  },
  { 
    path: '/appointments', 
    name: 'appointments-history',
    component: () => import('../views/Appointments/AppointmentsHistory.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/success',
    name: 'BookingSuccess',
    component: () => import('../views/Booking/BookingSuccess.vue'),
    meta: { requiresAuth: true }
  },
  { 
    path: '/profile', 
    name: 'profile',
    component: () => import('../views/Profile/Profile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/recharge/status',
    name: 'RechargeStatus',
    component: () => import('../views/Recharges/RechargeStatus.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/Register/RegisterView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: () => import('@/views/Notifications/Notifications.vue'), // Crea questo file
    meta: { requiresAuth: true }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL || '/'),
  routes,
})

  router.beforeEach((to, from, next) => {

      console.log("📍 Navigazione verso:", to.name, "da:", from.name)
      const urlParams = new URLSearchParams(window.location.search)

      if ((urlParams.get('recharge') === 'success' || urlParams.get('success') === 'true') && urlParams.get('step') === '4') {

          if (to.name !== 'booking-wizard') {

              return next({ name: 'booking-wizard', query: { step: '4', recharge: 'success' } })
          }
      }

      const piniaAuthRaw = localStorage.getItem('auth')
      let hasUserToken = !!localStorage.getItem('user-token')
      let isDeviceRegistered = localStorage.getItem('device-registered') === 'true'


      if (piniaAuthRaw) {

          try {

              const piniaAuth = JSON.parse(piniaAuthRaw)

              if (piniaAuth.token) hasUserToken = true

              if (piniaAuth.deviceRegistered || piniaAuth.isDeviceRegistered) isDeviceRegistered = true
          } 
          catch (e) {
          
              console.error("Errore nel parsing della cache di Pinia", e)
          }
      }

      const isPagineAuth = to.name === 'auth' || to.name === 'login' || to.name === 'register' || to.path === '/'

      if (hasUserToken || isDeviceRegistered) {

          if (to.name === 'intermedia') {

              return next({ name: hasUserToken ? 'user-menu' : 'login' })
          }
          
          if (hasUserToken && isPagineAuth && to.name !== 'user-menu') {

              return next({ name: 'user-menu' })
          }
          
          return next()
      }

      if (!isDeviceRegistered && !hasUserToken) {
      
        if (to.name !== 'intermedia' && !isPagineAuth) {
      
            console.log("🛑 BLOCCATO! Il Guard sta forzando Intermedia per la rotta:", to.name);
            return next({ name: 'intermedia' })
        }
      }
      next()
  })

export default router